import { Component, EventEmitter, OnInit, Output, } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { ThemingService } from 'src/app/theming.service';
import { LambdaService } from 'src/app/lambda.service';

declare var $: any;

@Component({
  selector: 'app-create-menu',
  templateUrl: './create-menu.component.html',
  styleUrls: ['./create-menu.component.scss']
})
export class CreateMenuComponent implements OnInit {
  @Output() creationMenuSuccess = new EventEmitter<void>();
  menu = {
    menuId: 0,
    menuName: '',
    menuStatus: 0
  };
  saveMenu = false;
  menus: any[] = [];
  pages: any[] = [];
  components: any[] = [];
  categories: any[] = [];
  collections: any[] = [];
  subCategories: any[] = [];
  subSubCategories: any[] = [];
  selectedOption: string = '';
  loading = false;
  menuOptions: any[] = [];
  itemListId: string = '';

  constructor(
    private apiService: ApiService,
    public themingService: ThemingService,
    private lambdaService: LambdaService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    Promise.all([
      this.getComponents(),
      this.getCollections(),
      this.getCategories(),
      this.getSubCategories(),
      this.getSubSubCategories(),
      this.getPages()
    ]).then(() => {
      this.loading = false;
    }).catch((error) => {
      console.error(error);
      this.loading = false;
    });
  }

  async getPages(): Promise<void> {
    this.loading = true;
    try {
      const response: any = await this.lambdaService.getPages(this.themingService.shopId);
      const pageRows = Array.isArray(response.data) ? response.data : [];
      this.pages = pageRows;
    } catch (error) {
      console.error('Error fetching pages:', error);
    } finally {
      this.loading = false;
    }
  }

  async getCategories(): Promise<void> {
    try {
      const response: any = await this.lambdaService.getCategories(this.themingService.shopId);
      const categoryRows = Array.isArray(response[0]) ? response[0] : [];
      this.categories = categoryRows;
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  }

  async getCollections(): Promise<void> {
    try {
      const response: any = await this.lambdaService.getCollections(this.themingService.shopId);
      this.collections = Array.isArray(response.collections) ? response.collections : [];
    } catch (error) {
      console.error('Error fetching collections:', error);
      this.collections = [];
    }
  }

  async getSubCategories(): Promise<void> {
    this.loading = true;
    try {
      const response: any = await this.lambdaService.getSubCategories(this.themingService.shopId);
      this.subCategories = Array.isArray(response.subCategories) ? response.subCategories : [];
    } catch (error) {
      console.error('Error fetching subCategories:', error);
    } finally {
      this.loading = false;
    }
  }

  async getSubSubCategories(): Promise<void> {
    try {
      const response: any = await this.lambdaService.getSubSubCategories(this.themingService.shopId);
      const subSubCategoryRows = Array.isArray(response.subSubCategories) ? response.subSubCategories : [];
      this.subSubCategories = subSubCategoryRows;
    } catch (error) {
      console.error('Error fetching subSubCategories:', error);
    }
  }

  async getComponents(): Promise<void> {
    this.loading = true;
    try {
      const response: any = await this.lambdaService.getComponents(this.themingService.shopId);
      const componentRows = Array.isArray(response[0]) ? response[0] : [];
      this.components = componentRows;
    } catch (error) {
      console.error('Error fetching components:', error);
    } finally {
      this.loading = false;
    }
  }

  ChangeMenuName(event: Event) {
    const element = event.target as HTMLInputElement;
    this.menu.menuName = element.value;
  }

  addMenuOption() {
    this.menuOptions.push({
      optionType: '',
      optionName: '',
      optionId: 0,
      categoryId: 0,
      subCategoryId: 0,
      subSubCategoryId: 0,
      collectionId: 0,
      optionUrl: '',
      position: this.menuOptions.length + 1,
      componentId: 0,
      pageId: 0,
      children: [],            // <-- nuevo
    });
  }

  addSubMenuOption(parentIndex: number) {
      this.menuOptions[parentIndex].children.push({
      optionType: '',
      optionName: '',
      optionId: 0,
      categoryId: 0,
      subCategoryId: 0,
      subSubCategoryId: 0,
      collectionId: 0,
      optionUrl: '',
      componentId: 0,
      pageId: 0,
      children: [],
      position: this.menuOptions[parentIndex].children.length + 1            // <-- nuevo
    });
  }

  removeSubMenuOption(parentIndex: number, childIndex: number) {
  this.menuOptions[parentIndex].children.splice(childIndex, 1);
  // re-index positions si lo necesitas
  this.menuOptions[parentIndex].children.forEach((c: { position: any; }, i: number) => c.position = i + 1);
  }

  removeMenuOption(index: number) {
    this.menuOptions.splice(index, 1);
    this.menuOptions.forEach((option, i) => {
      option.position = i + 1;
    });
  }

  onOptionChange(option: string, index: number) {
    // Reset the selections
    this.menuOptions[index].categoryId = 0;
    this.menuOptions[index].subCategoryId = 0;
    this.menuOptions[index].subSubCategoryId = 0;
    this.menuOptions[index].collectionId = 0;
    this.menuOptions[index].optionUrl = '';
    this.menuOptions[index].optionType = 0;
    this.menuOptions[index].componentId = 0;
    this.menuOptions[index].pageId = 0;

    switch (option) {
      case 'categories':
        this.menuOptions[index].optionType = 1;
        break;
      case 'subCategories':
        this.menuOptions[index].optionType = 2;
        break;
      case 'subSubcategories':
        this.menuOptions[index].optionType = 3;
        break;
      case 'collections':
        this.menuOptions[index].optionType = 4;
        break;
      case 'custom':
        this.menuOptions[index].optionType = 5;
        break;
      case 'componentId':
        this.menuOptions[index].optionType = 6;
        break;
      case 'pages':
        this.menuOptions[index].optionType = 7;
        break;
    }
  }

  onPageChange(event: any, index: number) {
    const selectedPage = this.pages.find(page => page.pageId === +event.target.value);
    if (selectedPage) {
      this.menuOptions[index].pageId = selectedPage.pageId;
    }
  }

  onCategoryChange(event: any, index: number) {
    const selectedCategory = this.categories.find(category => category.categoryId === +event.target.value);
    if (selectedCategory) {
      this.menuOptions[index].categoryId = selectedCategory.categoryId;
    }
  }

  onSubCategoryChange(event: any, index: number) {
    const selectedSubCategory = this.subCategories.find(subCategory => subCategory.subCategoryId === +event.target.value);
    if (selectedSubCategory) {
      this.menuOptions[index].subCategoryId = selectedSubCategory.subCategoryId;
    }
  }

  onSubSubCategoryChange(event: any, index: number) {
    const selectedSubSubCategory = this.subSubCategories.find(subSubCategory => subSubCategory.subSubCategoryId === +event.target.value);
    if (selectedSubSubCategory) {
      this.menuOptions[index].subSubCategoryId = selectedSubSubCategory.subSubCategoryId;
    }
  }

  onCollectionChange(event: any, index: number) {
    const selectedCollection = this.collections.find(collection => collection.collectionId === +event.target.value);
    if (selectedCollection) {
      this.menuOptions[index].collectionId = selectedCollection.collectionId;
    }
  }

  onComponentChange(event: any, index: number) {
    const selectedComponent = this.components.find(component => component.componentId === +event.target.value);
    if (selectedComponent) {
      this.menuOptions[index].componentId = selectedComponent.componentId;
      if (selectedComponent.categoryId) {
        this.menuOptions[index].categoryId = selectedComponent.categoryId;
      }
      if (selectedComponent.subCategoryId) {
        this.menuOptions[index].subCategoryId = selectedComponent.subCategoryId;
      }
      if (selectedComponent.subSubCategoryId) {
        this.menuOptions[index].subSubCategoryId = selectedComponent.subSubCategoryId;
      }
      if (selectedComponent.collectionId) {
        this.menuOptions[index].collectionId = selectedComponent.collectionId;
      }
      if (selectedComponent.pageId) {
        this.menuOptions[index].pageId = selectedComponent.pageId;
      }
    }
  }

  onUrlChange(event: any, index: number) {
    this.menuOptions[index].optionUrl = event.target.value;
  }

  isValidHttpUrl(url: string): boolean {
    if (!url) return false;
    const pattern = /^https?:\/\/[\w\-]+(\.[\w\-]+)+([\/\w\-._~:?#[\]@!$&'()*+,;=]*)?$/;
    return pattern.test(url);
  }

  validateFormData() {
    if (!this.menu.menuName?.trim()) {
      $('#requiredMenuModal').modal('show');
      return;
    }
    for (let i = 0; i < this.menuOptions.length; i++) {
      const opt = this.menuOptions[i];
      if (!opt.optionName?.trim() || !opt.optionType) {
        $('#requiredMenuModal').modal('show');
        return;
      }
      switch (opt.optionType) {
        case 1: // categories
          if (!opt.categoryId) { $('#requiredMenuModal').modal('show'); return; }
          break;
        case 2: // subCategories
          if (!opt.subCategoryId) { $('#requiredMenuModal').modal('show'); return; }
          break;
        case 3: // subSubcategories
          if (!opt.subSubCategoryId) { $('#requiredMenuModal').modal('show'); return; }
          break;
        case 4: // collections
          if (!opt.collectionId) { $('#requiredMenuModal').modal('show'); return; }
          break;
        case 5: // custom URL
          if (!opt.optionUrl || !this.isValidHttpUrl(opt.optionUrl)) {
            this.itemListId = `${i + 1}`;
            $('#errorCreateMenuUrl').modal('show');
            return;
          }
          break;
        case 6: // components
          if (!opt.componentId) { $('#requiredMenuModal').modal('show'); return; }
          break;
        case 7: // pages
          if (!opt.pageId) { $('#requiredMenuModal').modal('show'); return; }
          break;
        default:
          $('#requiredMenuModal').modal('show');
          return;
      }
    }

    for (let i = 0; i < this.menuOptions.length; i++) {
      const parent = this.menuOptions[i];
      const children = parent.children || [];
      for (let j = 0; j < children.length; j++) {
        const child = children[j];
        if (!child.optionName?.trim() || !child.optionType) {
          this.itemListId = `S${i + 1}.${j + 1}`;
          $('#requiredMenuModal').modal('show');
          return;
        }
        switch (child.optionType) {
          case 1:
            if (!child.categoryId) { $('#requiredMenuModal').modal('show'); return; }
            break;
          case 2:
            if (!child.subCategoryId) { $('#requiredMenuModal').modal('show'); return; }
            break;
          case 3:
            if (!child.subSubCategoryId) { $('#requiredMenuModal').modal('show'); return; }
            break;
          case 4:
            if (!child.collectionId) { $('#requiredMenuModal').modal('show'); return; }
            break;
          case 5:
            if (!child.optionUrl || !this.isValidHttpUrl(child.optionUrl)) {
              this.itemListId = `S${i + 1}.${j + 1}`;
              $('#errorCreateMenuUrl').modal('show');
              return;
            }
            break;
          case 6:
            if (!child.componentId) { $('#requiredMenuModal').modal('show'); return; }
            break;
          case 7:
            if (!child.pageId) { $('#requiredMenuModal').modal('show'); return; }
            break;
          default:
            $('#requiredMenuModal').modal('show');
            return;
        }
      }
    }
    this.createMenu();
  }

  createMenu() {
    this.loading = true;
    const payload = {
      menuId: 0,
      menuName: this.menu.menuName,
      menuStatus: this.menu.menuStatus || 0,
      menuOptions: this.menuOptions
    };
    this.lambdaService.createMenu(
      this.themingService.shopId,
      payload
    )
    .then((data: any) => {
      if (data?.success) {
        this.loading = false;
        this.resetForm();
        $('#successMenuModal').modal('show');
        $('#successMenuModal').on('hidden.bs.modal', () => this.creationMenuSuccess.emit());
      } else {
        this.loading = false;
        $('#errorMenuModal').modal('show');
      }
    })
    .catch(err => {
      console.error('createMenu error:', err);
      this.loading = false;
      $('#errorMenuModal').modal('show');
    });
  }

  resetForm() {
    this.menu = {
      menuId: 0,
      menuName: '',
      menuStatus: 0
    };
    this.menuOptions = [];
    this.saveMenu = false;
  }

  closeModal(): void {
    $('#successMenuModal').modal('hide');
    $('#errorMenuModal').modal('hide');
    $('#requiredMenuModal').modal('hide');
    $('#errorCreateMenuUrl').modal('hide');
  }
}
